import { render, staticRenderFns } from "./Exam.vue?vue&type=template&id=a60ea9c0"
import script from "./Exam.vue?vue&type=script&lang=ts"
export * from "./Exam.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports